
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
    Container,
    Jumbotron
    
}from 'reactstrap';

export default class Home extends Component {
  render() {
    return (
      <div>
        
            <Jumbotron id="menuBack">
                <h1>Our Menu</h1>
                <h2>OPEN EVERYDAY from 8:00am - 5:00pm
                <br/>Menu Varies Depending on Weekday or Weekend</h2>
                <div className="row">
                  <div className="col-md-4">
                  <ul className="list-group changer">
                  <li className='list-group-item'><h3>Weekday Menu</h3></li>
                  <li className='list-group-item'><p>Burritos $2.00 - Your choice of filling</p></li>
                  <li className='list-group-item'><p>Gorditas $2.00 - Your choice of filling</p></li>
                  <li className='list-group-item'><p>** Plus you can add rice, refried beans, and cheese for free! And add any other topping for just $1.00 **</p></li>
                </ul>
                  </div>
                  <div className="col-md-4">
                  <ul className="list-group changer">
                  <li className='list-group-item'><h3>What's The Filling?</h3></li>
                  <li className='list-group-item'><p>Guisado Rojo (Pork meat w/ potatoes in our famous Red Sauce)</p></li>
                  <li className='list-group-item'><p>Guisado Verde (Pork meat w/ potatoes in our famous Green Sauce)</p></li>
                  <li className='list-group-item'><p>Chicharron (Fresh Pork Rinds fried in our famous Green Sauce)</p></li>
                  <li className='list-group-item'><p>Bistec a la Mexicana (Grilled Steak with grilled onions, tomatoes, potatoes, & cilantro)</p></li>
                  <li className='list-group-item'><p>Picadillo (Beef and Potatoes w/ our Special Rio Seasoning)</p></li>
                  <li className='list-group-item'><p>Rajas y Queso (Sliced Poblano Peppers cooked in our seasoning w/ cheese)</p></li>
                  <li className='list-group-item'><p>Frijoles y Queso (Refried Beans w/ cheese)</p></li>
                  <li className='list-group-item'><p>Barbacoa (Only on Saturdays & Sundays)</p></li>
                  <li className='list-group-item'><p>Carnitas (Only on Saturdays & Sundays</p></li>
                </ul>
                  </div>
                  <div className="col-md-4">
                  <ul className="list-group changer">
                  <li className='list-group-item'><h3>Weekend Menu</h3></li>
                  <li className='list-group-item'><p>Barbacoa by the pound (w/ Pico de Gallo & Salsa on the side) $10.00</p></li>
                  <li className='list-group-item'><p>Carnitas by the pound (w/ Pico de Gallo & Salsa on the side) $10.00</p></li>
                  <li className='list-group-item'><p>Menudo $8.00</p></li>
                </ul>
                  </div>
                </div>
                <Container id="gallery">
                  <br/> <br/>
                  <div><h3 id="galWord">Gallery</h3></div>
                  <div className="row">
                    <div className="col-md-4">
                      <h2>Burritos</h2>
                      <img className="img-fluid" alt="burritos" src="./images/burritos.jpg"/>
                    </div>
                    <div className="col-md-4">
                      <h2>Gorditas</h2>
                      <img className="img-fluid" alt="gorditas" src="http://res.cloudinary.com/bobbynicholsoncloud/image/upload/a_360/v1530122038/new/stuffed.jpg"/>
                    </div>
                    <div className="col-md-4">
                      <h2>Barbacoa</h2>
                      <img className="img-fluid" alt="barbacoa" src="./images/barbacoa.jpg"/>
                    </div>
                  </div>
                  <div className="row">
                  <div className="col-md-4">
                      <h2>Carnitas</h2>
                      <img className="img-fluid" alt="carnitas" src="http://res.cloudinary.com/bobbynicholsoncloud/image/upload/a_90/v1530122024/new/carnitas.jpg"/>
                    </div>
                  <div className="col-md-4">
                      <h2>Tortilla Chips</h2>
                      <img className="img-fluid" alt="tortilla chips" src="./images/tort.jpeg"/>
                    </div>
                    <div className="col-md-4">
                      <h2>Menudo</h2>
                      <img className="img-fluid" alt="menudo" src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122028/new/menudo.jpg"/>
                    </div>
                   
                  </div>
                    <br/><br/>

                  <div className="row" id="diffList">
                    <div className="col-md-12">
                      <ul className="list-group">
                        <li className="list-group-item"><h2>Every-day Items</h2></li>
                        <li className="list-group-item">Chile de Arbol (Red Sauce)</li>
                        <li className="list-group-item">24oz. Bags of Chips</li>
                        <li className="list-group-item">Chile Verde (Green Sauce)</li>
                        <li className="list-group-item">Avocado Sauce</li>
                        <li className="list-group-item">Ready to cook Nopales (cactus)</li>
                        <li className="list-group-item">Red Tortillas (Tortillas Enchiladas) 2lb</li>
                        <li className="list-group-item">Salsa Tatemada (Chunky roasted pepper sauce)</li>
                        <li className="list-group-item">Mexican Cheese</li>

                      </ul>
                    </div>
                  </div>
                </Container>
                
            </Jumbotron>
        
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Menu.js